import { AnyAction } from 'redux';
import { ECostFormulaActionType, ICostFormulasState } from 'store/cost-formulas/types';

const initialState: ICostFormulasState = {
  error: null,
  loading: false,
  data: [],
};

function reducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case ECostFormulaActionType.GET_COST_FORMULAS: {
      return {
        ...state,
        loading: true,
      };
    }

    case ECostFormulaActionType.GET_COST_FORMULAS_SUCCESS: {
      const { formulaGroups } = action;
      return {
        ...state,
        loading: false,
        data: formulaGroups,
      };
    }

    case ECostFormulaActionType.GET_COST_FORMULAS_FAIL: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error,
      };
    }

    default: {
      return state;
    }
  }
}

export default reducer;
